import { IAttachmentModel } from './../../../../../../models/attachment/attachment.model';
import { AttachmentHelper } from './../../../../../../services/helpers/attachment.helper';
import { NodeInstanceViewModel } from './../../../../../../models/node/node-instance.view.model';
import { ExportHelper } from './../../../../../../services/helpers/export-helper';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TestStep } from '../../models/test-step.model';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { WorkspaceTableAttachmentsComponent } from '../../../../components/workspace/attachment/workspace-table-attachment/workspace-table-attachment.component';
import _ from 'lodash';
import { FIELD_VALUE_UNASSIGNED_LOWER, FIELD_NAME_STATUS_LOWER, PRIORITY_FIELD_LOWER } from '../../../../../../modules/catch-core/data/constants/blueprint.constants';
import { BlueprintDataHelper } from '../../../../../../services/helpers/blueprint-data.helper';
import { AttachmentConstants } from '../../../../../../modules/catch-core/data/constants/attachment.constants';
import { NODE_STATUS_TO_DO_LOWER } from '../../../../../../modules/catch-core/data/constants/app.constants';
import { BlueprintStore } from '../../../../../../services/stores/blueprint.store';
import { Subscription } from 'rxjs';
import { EditPanelTestStepHelperService } from '../../../../services/edit-panel-test-step.helper';
import { isRichTextHtml, normalizeBlankLinesForDisplay, sanitizeRichTextHtml } from './../../../../../../services/helpers/rich-text-content.helper';
import { RichTextAttachmentHelper } from './../../../../../../services/helpers/rich-text-attachment.helper';
import { ImageLightboxService } from './../../../../../../services/helpers/image-lightbox.service';
@Component({
  selector: 'app-test-step-table',
  templateUrl: './test-step-table.component.html',
  styles: [
    `
      :host ::ng-deep .p-dialog .product-image {
        width: 150px;
        margin: 0 auto 2rem auto;
        display: block;
      }
    `,
  ],
  styleUrls: ['./test-step-table.component.scss'],
  standalone: false,
})
export class TestStepTableComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input() inputTableData: TestStep[] = [];
  @Input() nodeData?: NodeInstanceViewModel;
  @Input() inputTableConfig: any[] = []; // not using at the moment
  @Input() tableName: string = ''; // may be use in future
  @Input() tableIndex: number | null = null; // index of table field in parent field list
  @Input() isAutoNumberColumn: boolean = false; // may be use in future
  @Input() workspaceName?: string = '';
  @Input() attachmentsOrg: IAttachmentModel[] = [];
  @Input() projectName: string = '';
  @Input() projectId: string = '';
  @Input() workspaceId: string = '';
  /** Backlog roll-up: the steps shown belong to another label, so they cannot be changed here. */
  @Input() readOnly = false;
  @Output() outputTableDataEvent = new EventEmitter<any>();
  @Output() tableEditEvent = new EventEmitter<any>();

  testStepData = {};

  first = 0;
  rows = 10;

  statuses: SelectItem[];
  selectedTestSteps: any;
  cols: any[];
  exportColumns: any[] = [];
  numberOfFiles;
  // The step columns that render as rich text. Drives the cell loop in the template so the
  // five identical cells aren't written out (and kept in sync) by hand. Order matters — it
  // is the column order, and must match the <th> list above it.
  public readonly richTextStepFields: string[] = ['description', 'expectedResult', 'data', 'notes', 'actualResult'];
  private blueprintSub?: Subscription;
  private boundTableKeydownCapture?: (event: KeyboardEvent) => void;
  // dataset keys for the data-step-id / data-step-field attributes on each editable <td>.
  private static readonly STEP_ID_DATA_KEY = 'stepId';
  private static readonly STEP_FIELD_DATA_KEY = 'stepField';
  @ViewChild('dt') dt?: Table;

  constructor(
    private exportHelper: ExportHelper,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public dialog: MatDialog,
    private attachmentHelper: AttachmentHelper,
    private blueprintStore: BlueprintStore,
    private editPanelTestStepHelper: EditPanelTestStepHelperService,
    private richTextAttachmentHelper: RichTextAttachmentHelper,
    private imageLightboxService: ImageLightboxService,
    private blueprintDataHelper: BlueprintDataHelper,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private elementRef: ElementRef<HTMLElement>,
  ) {
    this.statuses = [];

    // TODO: this needs to be dynamically populated from blueprint
    this.cols = [
      { field: 'id', header: 'Id' },
      { field: 'description', header: 'Description' },
      { field: 'expectedResult', header: 'Expected Result' },
      { field: 'data', header: 'Data' },
      { field: 'notes', header: 'Notes' },
      { field: 'actualResult', header: 'Actual Result' },
      { field: 'attachments', header: 'Attachments' },
      { field: 'teststatus', header: 'Status' },
      { field: 'bugs', header: 'Bugs' },
    ];
    this.numberOfFiles = '';
  }

  ngOnChanges(inputdata: any) {
    this.testStepData = inputdata;
    // Resolved HTML is keyed by the raw field value, so entries for the previous node are
    // dead weight once a different node is shown — and they hold base64 thumbnails. Drop
    // them rather than letting the map grow for the whole session.
    if (inputdata?.nodeData) {
      this.resolvedFieldHtmlCache.clear();
    }
    this.refreshStatuses();
  }
  ngOnInit() {
    this.refreshStatuses();
    this.blueprintSub = this.blueprintStore.$selectedBluePrint.subscribe(() => this.refreshStatuses());
    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));
    // console.log('this.nodeData', this.nodeData);
  }

  ngAfterViewInit(): void {
    // Capture phase, not bubble: primeng/select's own onTabKey (bound on its internal focus
    // element, a descendant of our Status <td>) unconditionally calls event.stopPropagation()
    // on every Tab keydown, closed overlay or not, and only calls preventDefault() when its
    // overlay is open. With the overlay closed — the normal state once a status is picked —
    // that leaves the browser's native Tab free to run, and the stopPropagation() means it
    // never bubbles out to PrimeNG's own EditableColumn (the td's moveToNextCell, which
    // correctly wraps into the next row for every other column in this table) either. A
    // bubble-phase listener of ours on an ancestor would be silenced the same way; only a
    // capture-phase listener runs early enough to see the keydown before Select's handler does.
    this.boundTableKeydownCapture = this.onTableKeydownCapture.bind(this);
    this.elementRef.nativeElement.addEventListener('keydown', this.boundTableKeydownCapture, true);
  }

  ngOnDestroy(): void {
    this.blueprintSub?.unsubscribe();
    this.resolvedFieldHtmlCache.clear();
    if (this.boundTableKeydownCapture) {
      this.elementRef.nativeElement.removeEventListener('keydown', this.boundTableKeydownCapture, true);
    }
  }

  // PrimeNG's onEditComplete fires on every Tab/click out of a cell, changed or not, so the cell's
  // value is snapshotted when it opens and only a real change is pushed (and so patched).
  //
  // The cell is identified from the data-step-id/data-step-field attributes on the <td>, read off
  // the Table's own editingCell - NOT from [pEditableColumn]/[pEditableColumnField]. Binding the
  // row object there looks like the obvious route, but EditableColumn.onChanges calls
  // updateEditingCell() on every row-data reference change, and every save rebuilds the step
  // objects, so each cell in the table then claimed to be "the" editing cell: Tab and clicks closed
  // that phantom cell (a patch each time) and the cell actually clicked never became editable.
  //
  // A null snapshot means onEditComplete is closing a cell the user never opened - PrimeNG marks
  // cells as editing on first render too (the same onChanges path) - so there is nothing to save.
  private editingCellSnapshot: { stepId: string; field: string; value: unknown } | null = null;

  public onEditComplete(event: any) {
    const snapshot = this.editingCellSnapshot;
    this.editingCellSnapshot = null;
    if (!snapshot) {
      return;
    }
    if (this.getStepFieldValue(snapshot.stepId, snapshot.field) !== snapshot.value) {
      this.pushTableDataToParentComponent();
    }
  }
  public onEditInit(event: any) {
    this.editingCellSnapshot = this.snapshotOpenCell();
    this.tableEditEvent.emit(event);
  }

  private snapshotOpenCell(): { stepId: string; field: string; value: unknown } | null {
    const cell = this.dt?.editingCell as HTMLElement | null | undefined;
    const stepId = cell?.dataset?.[TestStepTableComponent.STEP_ID_DATA_KEY];
    const field = cell?.dataset?.[TestStepTableComponent.STEP_FIELD_DATA_KEY];
    if (!stepId || !field) {
      return null;
    }
    return { stepId, field, value: this.getStepFieldValue(stepId, field) };
  }

  private getStepFieldValue(stepId: string, field: string): unknown {
    const step = this.inputTableData?.find((s) => s != null && String(s.id) === stepId);
    return step ? (step as unknown as Record<string, unknown>)[field] : undefined;
  }

  // An inline image in description/expectedResult/data/notes/actualResult uploads as a
  // real attachment (see RichTextFieldComponent / RichTextAttachmentHelper) but that
  // upload has no notion of "this belongs to test step N" — the step's own attachments
  // array is purely client-side bookkeeping (same convention as the paperclip attach
  // flow in OrgAttachmentsComponent), so record it here and save immediately so the
  // reference isn't lost if the user navigates away before completing the cell edit.
  //
  // The save is unconditional: recordStepAttachment's false only means the attachments array
  // already held this id, which is the normal case here — the picker dialog pushes the id onto
  // this very step object before it emits. What has to be persisted either way is the step
  // field's HTML, which just gained the image reference. Returning early on false left that
  // edit sitting in the client and it was lost when the panel reloaded the node.
  public onStepFieldImageAttached(testData: TestStep, attachmentId: string): void {
    if (this.readOnly || !testData || !attachmentId) {
      return;
    }
    this.editPanelTestStepHelper.recordStepAttachment(testData, attachmentId);
    this.pushTableDataToParentComponent();
  }

  public stepImageNamePrefix(step: TestStep): string {
    const nodeKey = this.nodeData?.key;
    return nodeKey && step?.id != null ? `${nodeKey}${AttachmentConstants.STEP_NAME_INFIX}${step.id}` : '';
  }

  // Track rows by id so JSON.parse-driven rebuilds of fieldDataArray don't
  // destroy/recreate the editing cell — that leaves PrimeNG's editingCell
  // pointing at a detached element and breaks subsequent inline edits.
  public trackByStepId = (_index: number, step: TestStep): number => step.id;

  public onAddTestStep(index: number) {
    if (this.readOnly) return;
    this.addNewRecordToTable(index + 1, null);
    this.pushTableDataToParentComponent();
  }

  // duplicate test step in the table
  public onDuplicateTestStep(index: number) {
    if (this.readOnly) return;
    if (index > 0) {
      this.addNewRecordToTable(index + 1, this.inputTableData[index - 1]);
      this.pushTableDataToParentComponent();
    }
  }

  public onDeleteTestStep(testStepData: TestStep) {
    if (this.readOnly) return;
    if (this.inputTableData.length <= 1) return;
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ' + testStepData.description + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const currentTestStepArray = this.inputTableData.filter((val) => val.id !== testStepData.id);
        this.inputTableData = this.sortTableById(currentTestStepArray);
        this.testStepData = {};
        this.messageService.add({
          severity: 'success',
          summary: 'Successful',
          detail: 'Test Step Deleted',
          life: 3000,
        });
        this.pushTableDataToParentComponent();
      },
    });
  }

  public onRowReorder(event: any) {
    if (this.readOnly) return;
    const copyOfTestStepTable = [...this.inputTableData];
    this.inputTableData = this.sortTableById(copyOfTestStepTable);
    this.pushTableDataToParentComponent();
  }

  public onLoadUploadComponent(rowIndex: number) {
    if (this.readOnly) return;
    if (rowIndex > -1 && this.inputTableData.length > rowIndex) {
      const dialogRef = this.dialog.open(WorkspaceTableAttachmentsComponent, {
        data: this.inputTableData[rowIndex],
        width: '700px',
        height: '95vh',
      });
      dialogRef.componentInstance.onAttachmentSaved.subscribe((data: any) => {
        if (data) {
          if (data) {
            this.replaceTableRow(data);
          }
        }
      });
      dialogRef.afterClosed().subscribe((result) => { });
    }
  }

  public onGetAttachmentCount(rowIndex: number) {
    const dataRow = this.inputTableData[rowIndex];

    if (dataRow) {
      if (dataRow.attachments) {
        return '(' + dataRow.attachments.length + ')';
        // if (dataRow.attachments.length === 1) {
        //   return '(' + dataRow.attachments.length + ') File';
        // } else {
        //   return '(' + dataRow.attachments.length + ') Files';
        // }
      }
    }
  }

  public onExportExcel() {
    let tableData = this.constructTestStepsTable();

    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(tableData);
      xlsx.utils.sheet_add_aoa(
        worksheet,
        [
          [
            // Matches the Do view's "Export Test Steps" column naming (do-table.component.ts's
            // getTestStepsPdfColumns / onExportTestStepsAsExcel headers) so the two exports read
            // consistently.
            'Key',
            'Summary',
            'Description',
            'Start Date',
            'Due Date',
            'Priority',
            'Assignee',
            'Status',
            'Test Step Id',
            'Test Step Description',
            'Test Step Expected Result',
            'Test Step Data',
            'Test Step Notes',
            'Test Step Actual Result',
            'Test Step Attachments',
            'Test Step Status',
          ],
        ],
        { origin: 'A1' },
      );
      const workbook = { Sheets: { 'Test Nodes with Test steps': worksheet }, SheetNames: ['Test Nodes with Test steps'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.exportHelper.saveAsExcelFile(excelBuffer, this.exportHelper.getExportFileName('Test with test steps of', this.projectName, this.workspaceName, '', this.nodeData?.key));
    });
  }

  private formatDateToPdfTable(nodeDate: string): string {
    return +nodeDate.slice(0, 4) > 2020 ? nodeDate.slice(0, 10) : '';
  }

  // node.priority/node.status carry the raw stored value (an option id post-migration, or
  // legacy display text) — resolve back to the user-facing label via the blueprint's
  // statusOptions for this node's type, same as do-table.component.ts's
  // getNodePriorityText/getNodeStatus, which this export's columns are meant to match. Without
  // this the export prints raw GUIDs instead of e.g. "High"/"In Progress".
  private getNodePriorityText(): string {
    if (!this.nodeData) return '';
    const priorityField = this.blueprintDataHelper.findFieldByCategory(this.nodeData.nodeType ?? '', PRIORITY_FIELD_LOWER);
    const priorityOptions = (priorityField?.value as any)?.statusOptions ?? (priorityField?.value as any)?.StatusOptions ?? [];
    return this.blueprintDataHelper.resolveStatusText(priorityOptions, this.nodeData.priority ?? '');
  }

  private getNodeStatusText(): string {
    if (!this.nodeData) return '';
    const statusField = this.blueprintDataHelper.findFieldByCategory(this.nodeData.nodeType ?? '', FIELD_NAME_STATUS_LOWER);
    const statusOptions = (statusField?.value as any)?.statusOptions ?? (statusField?.value as any)?.StatusOptions ?? [];
    return this.blueprintDataHelper.resolveStatusText(statusOptions, this.nodeData.status ?? '');
  }

  private constructTestStepsTable() {
    const testStepTableData = this.inputTableData.map((step) => ({
      testKey: step.id === 1 ? this.nodeData?.key : '',
      testName: step.id === 1 ? this.nodeData?.name : '',
      testDescription: step.id === 1 ? this.nodeData?.description : '',
      startDate: step.id === 1 && this.nodeData?.startDate ? this.formatDateToPdfTable(this.nodeData.startDate.toString()) : '',
      dueDate: step.id === 1 && this.nodeData?.dueDate ? this.formatDateToPdfTable(this.nodeData.dueDate.toString()) : '',
      priority: step.id === 1 ? this.getNodePriorityText() : '',
      assignee: step.id === 1 ? (this.nodeData?.assignee?.fullName?.toLocaleLowerCase() === FIELD_VALUE_UNASSIGNED_LOWER ? '' : this.nodeData?.assignee?.fullName) : '',
      testStatus: step.id === 1 ? this.getNodeStatusText() : '',
      stepId: step.id,
      stepDescription: this.exportHelper.stripHtmlToPlainText(step.description),
      expectedResult: this.exportHelper.stripHtmlToPlainText(step.expectedResult),
      data: this.exportHelper.stripHtmlToPlainText(step.data),
      notes: this.exportHelper.stripHtmlToPlainText(step.notes),
      actualResult: this.exportHelper.stripHtmlToPlainText(step.actualResult),
      attachment: this.attachmentHelper.getAttachmentNamesByIds(step.attachments, this.attachmentsOrg),
      stepstatus: step.teststatus,
    }));

    return _.flatten(testStepTableData);
  }

  public isRichTextHtml(value: string | null | undefined): boolean {
    return isRichTextHtml(value);
  }

  // The read-only preview cell binds [innerHTML] directly to a step's stored rich-text
  // field (description/expectedResult/data/notes/actualResult), which only carries small
  // attachment-id references (not the image bytes) — resolve those to real images for
  // display, once per raw value, and cache the result (keyed by content, so it's shared
  // across fields/rows) so repeated renders of the same value don't re-fetch the image.
  // Wrapped as trusted HTML so Angular's [innerHTML] sanitizer doesn't strip the
  // data-attachment-id attribute that the hover-zoom styling and click-to-lightbox
  // handler (onFieldPreviewClick) depend on.
  public getResolvedFieldHtml(raw: string | null | undefined): SafeHtml {
    if (!raw) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }
    if (!this.resolvedFieldHtmlCache.has(raw)) {
      // Step fields are user-authored and stored, and can carry markup written outside Quill,
      // so scrub before anything reaches [innerHTML]. Scrubbing first also makes the DOM parse
      // inside resolveEmbeddedImages safe. bypassSecurityTrustHtml is still required afterwards
      // because Angular's sanitizer drops data-attachment-id — see sanitizeRichTextHtml.
      // A blank line pasted from Word arrives as a space-only paragraph, which has no height
      // once whitespace collapses here (the editor's white-space: pre-wrap hid that).
      const safeHtml = normalizeBlankLinesForDisplay(sanitizeRichTextHtml(raw));
      this.resolvedFieldHtmlCache.set(raw, safeHtml);
      this.richTextAttachmentHelper.resolveEmbeddedImages(safeHtml).subscribe({
        next: (resolved) => {
          this.resolvedFieldHtmlCache.set(raw, resolved);
          // The image fetch resolves on its own async HTTP round-trip, not from an @Input
          // change or template event, and this table sits under an OnPush ancestor
          // (edit-panel-container) — without this, Angular's change-detection tree-walk never
          // re-descends far enough to notice the cache update, so the placeholder never gets
          // swapped for the real thumbnail until something else (e.g. entering edit mode)
          // happens to mark this branch dirty.
          this.cdr.markForCheck();
        },
        // forkJoin over per-image fetches: one failure errors the whole stream. Leave the
        // scrubbed-but-unresolved HTML in the cache rather than throwing unhandled.
        error: (err) => console.error('Failed to resolve embedded images in step field', err),
      });
    }
    return this.sanitizer.bypassSecurityTrustHtml(this.resolvedFieldHtmlCache.get(raw) ?? '');
  }

  // Delegated capture-phase keydown handler for the whole table (see ngAfterViewInit for why
  // capture phase is required). Only plain Tab pressed while focus is inside the Status column
  // is of interest here — every other column's Tab handling already works via PrimeNG's own
  // EditableColumn, untouched by this.
  public onTableKeydownCapture(event: KeyboardEvent): void {
    if (event.key !== 'Tab' || event.shiftKey) {
      return;
    }
    const statusCell = (event.target as HTMLElement)?.closest?.('.status-cell') as HTMLElement | null;
    if (statusCell) {
      this.advanceFromStatusField(event, statusCell);
    }
  }

  // Takes over Tab navigation out of the Status cell, since primeng/select's own Tab handling
  // (see ngAfterViewInit) stops the keydown from ever reaching PrimeNG's own row-wrapping
  // logic. Reimplements just that: click the next row's first editable cell — its own onClick
  // handler (EditableColumn) closes this cell and opens that one, the same transition PrimeNG
  // already does for every other column — or, on the last row, do nothing further so Tab
  // simply stops instead of escaping the table.
  public advanceFromStatusField(event: KeyboardEvent, statusCell: HTMLElement): void {
    event.preventDefault();
    event.stopPropagation();
    const nextRow = statusCell.closest('tr')?.nextElementSibling;
    const nextCell = nextRow?.querySelector<HTMLElement>('.p-editable-column');
    nextCell?.click();
  }

  // The preview cell only ever shows a thumbnail (see getResolvedFieldHtml); clicking
  // it opens the shared lightbox to view the image at full resolution.
  public onFieldPreviewClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const attachmentId = target?.closest?.('img[data-attachment-id]')?.getAttribute('data-attachment-id');
    if (attachmentId) {
      event.stopPropagation();
      this.imageLightboxService.open(attachmentId);
    }
  }

  private resolvedFieldHtmlCache = new Map<string, string>();

  public getStatusName(status: string): string {
    if (!status) {
      return '';
    }
    const normalizedStatus = status.toLowerCase();
    if (normalizedStatus === NODE_STATUS_TO_DO_LOWER) {
      return 'notrun';
    }
    return normalizedStatus;
  }

  // page

  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  isLastPage(): boolean {
    return this.inputTableData ? this.first === this.inputTableData.length - this.rows : true;
  }

  isFirstPage(): boolean {
    return this.inputTableData ? this.first === 0 : true;
  }

  // private

  private pushTableDataToParentComponent() {
    this.outputTableDataEvent.emit({
      data: this.inputTableData,
      index: this.tableIndex,
    });
  }

  private replaceTableRow(dataRow: any): void {
    if (dataRow) {
      for (let i = 0; i < this.inputTableData.length; i++) {
        if (this.inputTableData[i].id === dataRow['id']) {
          this.inputTableData[i] = dataRow;
        }
      }
      this.pushTableDataToParentComponent();
    }
  }

  // private saveAsExcelFile(buffer: any, fileName: string): void {
  //   const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  //   const EXCEL_EXTENSION = '.xlsx';
  //   const data: Blob = new Blob([buffer], {
  //     type: EXCEL_TYPE,
  //   });
  //   FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  // }

  private addNewRecordToTable(newId: number, testStep: TestStep | null): void {
    let newStep: TestStep;

    if (!testStep) {
      newStep = this.getNewTestStepRecord(newId);
    } else {
      newStep = this.getDeepCopy(testStep);
    }
    const workspace = this.blueprintStore?.selectedBluePrint ? { bluePrintId: this.blueprintStore.selectedBluePrint.id } : undefined;
    newStep.teststatus = this.editPanelTestStepHelper.getDefaultStepStatus(workspace);

    // add new row to endaddNewRecordToTable
    if (newId === this.inputTableData.length + 1) {
      newStep.id = newId;
      this.inputTableData.push(newStep);
    } else {
      const copyOfTestStepTable = [...this.inputTableData];

      // add new row
      const tempTestStepTable = this.insertRowIntoNewIndex(copyOfTestStepTable, newId, newStep);

      // sorted
      this.inputTableData = this.sortTableById(tempTestStepTable);
    }
  }

  // insert row into specific index and return test steps array
  private insertRowIntoNewIndex(testStepTable: TestStep[], newId: number, newStep: TestStep): any[] {
    const tempTestStepTable = [];
    for (let i = 0; i < testStepTable.length; i++) {
      if (newId === i + 1) {
        tempTestStepTable.push(newStep);
      }
      tempTestStepTable.push(testStepTable[i]);
    }
    return tempTestStepTable;
  }

  private sortTableById(testStepArray: TestStep[]): TestStep[] {
    const tempTestStepDataArray = [];

    for (let i = 0; i < testStepArray.length; i++) {
      const tempStep = testStepArray[i];
      tempStep.id = i + 1;
      tempTestStepDataArray.push(tempStep);
    }

    return tempTestStepDataArray;
  }

  private getNewTestStepRecord(newId: number): TestStep {
    return {
      id: newId,
      description: '',
      expectedResult: '',
      data: '',
      notes: '',
      actualResult: '',
      attachments: [], // TODO - need to implement later
      teststatus: '',
      bugs: [], // TODO - need to implement later
    };
  }

  private getDeepCopy(obj: any) {
    return JSON.parse(JSON.stringify(obj));
  }

  private refreshStatuses(): void {
    const workspace = this.blueprintStore?.selectedBluePrint ? { bluePrintId: this.blueprintStore.selectedBluePrint.id } : undefined;
    const options = this.editPanelTestStepHelper.getTestStatusOptions(workspace);
    this.statuses = this.toSelectItems(options);
  }

  private toSelectItems(options: string[]): SelectItem[] {
    return (options ?? []).map((option) => ({ label: option, value: option }));
  }

  public getStatusStyle(status: string): Record<string, string> | null {
    if (!status) {
      return null;
    }
    const workspace = this.blueprintStore?.selectedBluePrint ? { bluePrintId: this.blueprintStore.selectedBluePrint.id } : undefined;
    return this.editPanelTestStepHelper.getTestStatusStyle(status, workspace);
  }
}
